<template>
  <span class="filter-tag" @click="_onclick()">{{name}}</span>
</template>

<script>
export default {
  components:{},
  props:{
      name: String
  },
  data(){
    return {
    }
  },
  watch:{},
  computed:{},
  methods:{
      _onclick() {
          this.$emit('click');
      }
  },
  created(){},
  mounted(){}
}
</script>
<style lang="scss" scoped>
.filter-tag {
  padding: 10px 16px;
  font-size: 14px;
  color: #5c74f5;
  line-height: 1;
  background-color: #fff;
  border: 1px solid #5c74f5;
  border-radius: 8px;
  cursor: pointer;
}
.filter-tag.active {
  color: #fff;
  background-color: #5c74f5;
}
</style>